import gql from 'graphql-tag';

const CREATE_RESOURCE_FAVORITE = gql`
  mutation createResourceFavorite($data: ResourceFavoriteCreateInput!) {
    createResourceFavorite(data: $data) {
      id
      resourceId
    }
  }
`;

export default CREATE_RESOURCE_FAVORITE;
